import { FC, useMemo } from 'react';
import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { FdrStaticRequestButton } from 'components/domain/fdr-request-button';
import { FdrPageComponentsFragment } from 'schemas/fragment/page-components/fdr-page-components.generated';
import { FdrRequestButtonFragment } from 'schemas/fragment/request-button/fdr-request-button.generated';
import { FdrPageComponents } from './fdr-page-components';

interface IFdrPageComponentsWithRequestButtonProps {
  components?: FdrPageComponentsFragment['components'];
  requestButton?: FdrRequestButtonFragment;
  requestButtonBgColor?: string;
}

const RequestButtonWrapper = styled.div(
  sx2CssThemeFn({
    '.static-request-button-wrapper': {
      mt: [-6, -8],
      pb: [6, 9],
      maxWidth: '818px',
      pl: [3, 0],
      pr: [3, 0],
    },
    '.large-text-width': {
      width: '100%',
      maxWidth: '1480px',
      pl: [3, '20px'],
      pr: [3, '20px'],
    },
  })
);

const FdrPageComponentsWithRequestButton: FC<IFdrPageComponentsWithRequestButtonProps> =
  ({ components, requestButton, requestButtonBgColor }) => {
    const firstMarkdownIndex = components?.findIndex(
      component => component.__typename === 'FdrMarkdownText'
    );

    const beforeRequestButtonComponents = useMemo(() => {
      return firstMarkdownIndex > -1
        ? components.slice(0, firstMarkdownIndex + 1)
        : components;
    }, [components, firstMarkdownIndex]);

    const afterRequestButtonComponents = useMemo(() => {
      return firstMarkdownIndex > -1
        ? components.slice(firstMarkdownIndex + 1)
        : [];
    }, [components, firstMarkdownIndex]);

    if (!components?.length) return null;

    if (firstMarkdownIndex === -1 || !requestButton) {
      return <FdrPageComponents components={components} />;
    }

    return (
      <>
        <FdrPageComponents components={beforeRequestButtonComponents} />
        <RequestButtonWrapper>
          <FdrStaticRequestButton
            backgroundColor={requestButtonBgColor}
            caption={requestButton.objectCaption || requestButton.staticCaption}
            link={requestButton.link}
          />
        </RequestButtonWrapper>
        <FdrPageComponents components={afterRequestButtonComponents} />
      </>
    );
  };

export default FdrPageComponentsWithRequestButton;
